import { render, staticRenderFns } from "./newDatePicker.vue?vue&type=template&id=20850816&scoped=true"
import script from "./newDatePicker.vue?vue&type=script&lang=ts"
export * from "./newDatePicker.vue?vue&type=script&lang=ts"
import style0 from "./newDatePicker.vue?vue&type=style&index=0&id=20850816&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20850816",
  null
  
)

export default component.exports